export default {
  imoveis: state => state.imoveis,
  imovel: state => state.imovel,
  tipoAnuncios: state => state.tipoAnuncios,
  tipoImoveis: state => state.tipoImoveis,
  tipoAreas: state => state.tipoAreas,
  motivos: state => state.motivos
}
